import { z } from 'zod';

export const AbilityTreeKeySchema = z.enum(['alchemy','armor_use','bow_use','conjuration','illusion','melee_combat','movement','spirit']);

export type AbilityTreeKeyType = `${z.infer<typeof AbilityTreeKeySchema>}`

export default AbilityTreeKeySchema;
